import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-500/10 border-t border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-base text-white"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">韩漫画网</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最专业的韩漫在线免费阅读平台，提供最新高清免费韩国漫画大全，热门韩漫一站式在线阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">漫画分类</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/love" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">恋爱韩漫</Link>
              <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">奇幻韩漫</Link>
              <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">动作韩漫</Link>
              <Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">剧情韩漫</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                contact@hanmanhua.com
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500"></i>
                微信公众号：韩漫画网
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-500"></i>
                正版授权 · 安全阅读
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 韩漫画网 HanManHua.com - 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}